/*
 * IMPORTS
 */
import { gql } from '@apollo/client'

/*
 * EXPORTS
 */
export default gql`
  query SenderRouteReadQuery($routeId: ID!) {
    SenderRouteRead(routeId: $routeId) {
      id
      displayName
      type
      CustomerAccount {
        id
        displayName
      }
    }
  }
`
